export default {
  "title": "Ghost Hunter",
  "intro": "Capai setiap milestone kontribusi tembakan untuk membuka hadiahnya. Semakin banyak kontribusi, semakin besar hadiahnya!",
  "login": "Masuk",
  "logout": "Keluar",
  "howToPlay": "Cara Bermain?",
  "contributeDesc": "Capai setiap milestone kontribusi tembakan untuk membuka hadiahnya. Semakin banyak kontribusi, semakin besar hadiahnya!",
  "account": "ID akun",
  "code": "Kode verifikasi",
  "sendCode": "Kirim kode verifikasi ke mailbox dalam game",
  "codeSent": "Kode verifikasi telah dikirim. Silakan periksa mailbox dalam game.",
  "submit": "Konfirmasi",
  "cancel": "Batal",
  "ok": "OK",
  "rewardConfirm": "Konfirmasi",
  "available": "Sisa Roket",
  "total": "Total serangan",
  "ghostDefeated": "Hantu telah dikalahkan",
  "globalTitle": "Progres Mengalahkan Hantu",
  "strikeTitle": "Serang",
  "strike": "Tembak!!!",
  "strikeRecord": "Tembak",
  "taskTitle": "Pertarungan Pemakaman",
  "missionClaimed": "Telah Diklaim",
  "missionCompleted": "Dapat Diklaim",
  "missionIncomplete": "Belum Tercapai",
  "share": "Bagikan",
  "sharing": "Membagikan",
  "shareOk": "Berhasil dibagikan",
  "milestoneTitle": "Tonggak pribadi",
  "times": "Kali",
  "recordTitle": "Riwayat Hadiah",
  "recordDialogTitle": "Riwayat Hadiah",
  "recordReward": "Hadiah",
  "recordTime": "Waktu Terima",
  "refresh": "Segarkan",
  "empty": "Data tidak tersedia",
  "receive": "Dapat Diklaim",
  "received": "Telah Diklaim",
  "notReady": "Belum Tercapai",
  "locked": "Terkunci",
  "unlocked": "Dapat Diklaim",
  "rewardTitle": "Hadiah",
  "phase": {
    "not_start": "Event belum dimulai",
    "play": "Event sedang berlangsung",
    "view_only": "Event telah berakhir",
    "closed": "Halaman ditutup"
  },
  "actTime": {
    "notStart": "Event belum dimulai",
    "ended": "Event telah berakhir",
    "startCountdown": "Hitung Mundur Menuju Mulai",
    "day": "Hari"
  },
  "taskCycle": {
    "daily": "Misi Harian",
    "weekly": "Misi Mingguan"
  },
  "tasks": {
    "hw_daily_login": "Login Harian",
    "hw_daily_play_any_1": "Mainkan 1 Mode Apa Saja",
    "hw_daily_play_any_3": "Mainkan 3 Mode Apa Saja",
    "hw_daily_mojin_3": "Mainkan Mode Mystic Raid 3 Kali",
    "hw_weekly_share": "Bagikan ke Media Sosial"
  },
  "props": {
    "90301916": "[Bingkai Avatar] Sugar Bomb",
    "70100101": "Diamond Emas",
    "70100011": "Gold",
    "50108900": "Canorus (3 days)",
    "70100004": "Kartu Poin",
    "80103001": "Rank Protection",
    "10301029": "Scythe-Hellbound (3 days)",
    "80102101": "Tiket Spin Diamond Emas",
    "82101002": "Flower",
    "80202003": "Kartu Upgrade Senjata LV3",
    "82101003": "Lollipop",
    "81010999": "Koin Pertumbuhan Universal",
    "70100013": "Mystic Voucher",
    "70100014": "Kunci Mystic",
    "10101086": "AK15-Rushou"
  },
  "footer": {
    "privacyPolicy": "Kebijakan Privasi",
    "userAgreement": "Perjanjian Pengguna",
    "customerService": "Harap hubungi kami melalui email di ministarcustomerservice{'@'}gmail.com"
  },
  "error": {
    "code401": "Status Login Kedaluwarsa",
    "code1001": "Parameter tidak valid",
    "code1004": "Coba lagi nanti",
    "code2001": "Event belum dimulai",
    "code2002": "Event telah berakhir",
    "code2003": "Halaman ditutup",
    "code2201": "Misi belum selesai",
    "code2202": "Hadiah telah diklaim",
    "code2203": "Tugas belum dikonfigurasi",
    "code2301": "Tidak ada kesempatan serangan",
    "code2401": "Node ini belum dibuka",
    "code2402": "Hadiah telah diklaim",
    "code2403": "Tahap tidak ditemukan",
    "code2501": "Syarat Milestone belum terpenuhi",
    "code2502": "Milestone telah diklaim",
    "code2503": "Tonggak tidak ditemukan",
    "code2801": "Hadiah telah diklaim",
    "code429": "Terlalu sering"
  },
  "howToPlayBody": "🎃 [Ghost Hunter] {'|'} Bersatu Kalahkan Hantu Raksasa\n \n Di malam Halloween, seekor hantu raksasa menyeruak masuk ke dunia Mini World Royale — menebar ancaman dan mengacaukan seluruh server! Tom Captain, Nonana, Lingyu, dan Starry Mecha memanggil seluruh Sharpshooter — kumpulkan daya tembak, luncurkan roket tanpa henti, dan hancurkan HP hantu ini lapis demi lapis. Bersatu untuk mengalahkan hantu raksasa ini dan lindungi malam Halloween!\n \n 📅 Jadwal Event\n Periode Partisipasi: 23 Okt – 9 Nov (GMT+8)\n Klaim/Penukaran Hadiah: Awal Event – 16 Nov (GMT+8)\n ※ Pastikan untuk mengklaim hadiah dalam periode yang ditentukan, hadiah yang tidak diklaim akan hangus.\n \n 🔥 Cara Bermain: 3 Langkah Mengalahkan Hantu Raksasa\n \n Langkah 1: Dapatkan Roket\n Masuk ke [Pertarungan Pemakaman] dan selesaikan Misi Harian/Mingguan untuk mendapatkan jumlah serangan!\n \n Langkah 2: Tembak! Serang Hantu Raksasa\n Ketuk [TEMBAK!!!] untuk menyerang hantu raksasa! Setiap tembakan akan langsung mengurangi HP hantu di seluruh server dan menambah poin kontribusi serangan pribadimu. Bekerja samalah dengan para pemburu di seluruh server untuk menghabiskan HP hantu! (Jumlah tembakan yang belum terpakai akan disimpan untuk hari berikutnya, tidak akan hangus.)\n \n Langkah 3: Buka Hadiah\n Hadiah Server: Setiap kali HP server berkurang hingga 25% / 50% / 75% / 100%, semua Sharpshooter yang berpartisipasi akan membuka hadiah tahap yang sesuai! Saat HP habis total dan hantu raksasa berhasil dikalahkan, semua pemain berhak mendapatkan Hadiah Utama!\n Hadiah Pribadi: Akumulasi kontribusi tembakanmu juga akan membuka [Milestone Pribadi] — semakin banyak menyerang, semakin banyak hadiah yang bisa diklaim!\n \n 🏆 Catatan Saya\n Semua riwayat serangan dan hadiah yang telah diklaim dapat dilihat di [Riwayat Hadiah].",
  "shareTitle": "Trick or Treat!!!",
  "shareContent": "Malam Halloween telah tiba — kalahkan hantu dan nikmati Hadiah Utama bersama seluruh server.\n Jangan biarkan hadiah yang sudah di tangan terlewat begitu saja!",
  "accountPlaceholder": "Silakan masukkan akun",
  "codePlaceholder": "Silakan masukkan kode verifikasi"
}
